import React from 'react'
import ReactDOM from 'react-dom'

// Redux stuff
import { Provider } from 'react-redux';
import store from './js/store/store';

// the app
import Configurator from './js/components/Configurator';

// default styles
import './styles/index.css';

ReactDOM.render(
    <Provider store={store}>
        <Configurator />
    </Provider>,
    document.getElementById('course-configurator')
);